// Exports the "fullpage" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/fullpage')
//   ES2015:
//     import 'tinymce/plugins/fullpage'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/fullpage/index.js